import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

interface SelectionFooterProps {
  totalCount: number;
  onAddAll: () => void;
}

export const SelectionFooter: React.FC<SelectionFooterProps> = ({
  totalCount,
  onAddAll,
}) => {
  return (
    <AnimatePresence>
      {totalCount > 0 && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.15, ease: 'easeInOut' }}
          className='overflow-hidden'
        >
          <div className='flex items-center justify-between border-t px-4 py-2.5'>
            <span className='text-sm text-muted-foreground'>
              {totalCount} {totalCount === 1 ? 'node' : 'nodes'} selected
            </span>
            <Button size='sm' onClick={onAddAll} className='h-7 gap-1.5'>
              <Plus className='size-3.5' />
              Add all
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
